import { saveImage } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useSendEssayImage(setImage: (uri: string) => void) {
  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['sendEssayImage'], 
    mutationFn: (body: { file: File, id: string }) => saveImage(body.file, body.id),
    onSuccess: (response) => {
      if(response.Location) {
        setImage(response.Location)
      }
    },
    retry: false
  });

  return { mutate, isPending, isError };
}